<div class="status-popover">
    <span id="status-icon">
        <ng-container *ngIf="iconDetail?.iconType === iconType.Completed; else inProgressTemplate">
            <svg class="icon-16 green-icon-fill">
                <use href="../App_Themes/CXone/icons/status-completed.svg#status-completed"></use>
            </svg>
            <span [innerHTML]="value| boldText:searchFilter:minSearchLength" class="textContent"></span>
        </ng-container>
        <ng-template #inProgressTemplate>
            <svg class="icon-16 yellow-icon-fill">
                <use href="../App_Themes/CXone/icons/timezone.svg#timezone"></use>
            </svg>
            <span [innerHTML]="value| boldText:searchFilter:minSearchLength" class="textContent"></span>
        </ng-template>
    </span>
</div>